/* @flow */

import * as React from 'react';

import {colors} from 'shells/colors';
import {TextRegularAiIcon} from 'shells/icon';
import {Stack} from 'shells/layout';
import {Body, SectionLabel} from 'shells/typography';
import type {Truncate} from 'shells/typography/body';

import type {EntitySummaryRating} from 'nutshell-graphql-types';

import {Footer} from './footer';

import './summary.module.css';

type Props = {|
    title?: string,
    summary: string,
    userRating?: ?EntitySummaryRating,
    isSavingRating?: boolean,
    truncate?: Truncate,
    onRate?: (rating: EntitySummaryRating) => Promise<*>,
|};

export function Summary(props: Props) {
    return (
        <div styleName='container'>
            {props.title && (
                <Stack isHorizontal={true} spacing={4} alignCenter={true}>
                    <TextRegularAiIcon
                        color={colors.aiPurplePrimary}
                        fill={colors.aiPurplePrimary}
                        size={20}
                        alignCenter={true}
                    />
                    <SectionLabel color='ai-purple' noBottomBorder={true}>
                        {props.title}
                    </SectionLabel>
                </Stack>
            )}
            <Stack spacing={8}>
                <Body size='small' color='dark' maintainLineBreaks={true} truncate={props.truncate}>
                    {props.summary}
                </Body>
                <Footer
                    userRating={props.userRating}
                    onRate={props.onRate}
                    isSavingRating={props.isSavingRating}
                />
            </Stack>
        </div>
    );
}
